"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var types = _interopRequireWildcard(require("./types"));
var _types2 = require("../session/types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  _searchResults: null,
  query: '',
  pending: [],
  acceptedContactsLoaded: false,
  pendingContactsLoaded: false,
  nbContacts: 0,
  currentPage: 1
};
var relationReducer = function relationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.SET_NB_CONTACTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        nbContacts: action.nbContacts
      });
    case types.ADD_NB_CONTACTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        nbContacts: state.nbContacts + action.nbToAdd
      });
    case types.SET_PENDING_CONTACTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        pending: [...(action.pendingContacts || [])]
      });
    case types.ADD_PENDING_CONTACT:
      return _objectSpread(_objectSpread({}, state), {}, {
        pending: [...state.pending, action._pendingContact]
      });
    case types.REMOVE_PENDING_CONTACT:
      return _objectSpread(_objectSpread({}, state), {}, {
        pending: state.pending.filter(e => e !== action._pendingContact)
      });
    case types.SET_ACCEPTED_CONTACTS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedContactsLoaded: action.loaded
      });
    case types.SET_CURRENT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: action.currentPage
      });
    case types.SET_PENDING_CONTACTS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        pendingContactsLoaded: action.loaded
      });
    case types.SET_SEARCH_QUERY:
      return _objectSpread(_objectSpread({}, state), {}, {
        query: action.query
      });
    case types.SET_SEARCH_CONTACT_RESULT:
      return _objectSpread(_objectSpread({}, state), {}, {
        _searchResults: action._searchResults
      });
    case _types2.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    default:
      return state;
  }
};
var _default = exports.default = relationReducer;
module.exports = exports.default;